import { Link, Navigate, Route, Routes } from "react-router-dom";
import DemoPlayer from "./player/DemoPlayer";
import Pricing from "./landing/Pricing";

function Nav() {
  return (
    <nav className="flex items-center gap-6 px-6 py-4 border-b border-white/10">
      <Link to="/demo" className="font-mono text-lg tracking-tight">
        1bit.vault
      </Link>
      <Link to="/demo" className="text-sm opacity-70 hover:opacity-100">
        demo
      </Link>
      <Link to="/pricing" className="text-sm opacity-70 hover:opacity-100">
        pricing
      </Link>
    </nav>
  );
}

export default function App() {
  return (
    <div className="min-h-full flex flex-col">
      <Nav />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Navigate to="/demo" replace />} />
          <Route path="/demo" element={<DemoPlayer />} />
          <Route path="/pricing" element={<Pricing />} />
        </Routes>
      </main>
    </div>
  );
}
